"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ownerDocument = _interopRequireDefault(require("@mui/utils/ownerDocument"));
var _default = exports.default = _ownerDocument.default;